import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';

@Component({
  selector: 'app-countries-modal',
  templateUrl: './countries-modal.component.html',
  styleUrls: ['./countries-modal.component.scss']
})
export class CountriesModalComponent implements OnInit {

  public regionsData: any;
  public regionValue: any;
  public editOb: any;
  public editData: any;
  public regionName: any;
  public regionId: any;
  successMsg: any;
  public model = {
    region_id: ''
  } ;
  public user = {
    name : '',
  };
  public editPermission = false;
  constructor(public dialogRef: MatDialogRef<CountriesModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.countries.edit'] == 1) {
        this.editPermission = true;
      }
    }
    this.masterService.getData('/regions/get').subscribe(res => {
      // @ts-ignore
      this.regionsData = res.data;
    });

    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;

      this.masterService.getRecordById(id, enc_id, '/countries/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
        if (this.editData.regions) {
          this.regionId  = this.editData.country.region_id;
          this.regionName = this.editData.regions.filter(regions => regions.id === this.regionId)[0].name;
        } else {
          this.regionName = '';
        }
      });
    }
  }


  submitForm(data) {
    if (this.editData) {
      // tslint:disable-next-line:variable-name max-line-length
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/countries/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/countries/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }
  close() {
    this.dialogRef.close();
  }

}
